// Shared metadata for the Administration / Finance Workspace.
// Keep in sync with /app/backend/administration/schemas.py.

export const RECORD_TYPES = [
  { code: "income",             label: "Rental income",     group: "income"  },
  { code: "deposit_received",   label: "Deposit received",  group: "deposit" },
  { code: "deposit_returned",   label: "Deposit returned",  group: "deposit" },
  { code: "refund",             label: "Refund to customer", group: "expense" },
  { code: "expense",            label: "General expense",   group: "expense" },
  { code: "vehicle_cost",       label: "Vehicle cost",      group: "expense" },
  { code: "maintenance_cost",   label: "Maintenance",       group: "expense" },
  { code: "repair_cost",        label: "Repair",            group: "expense" },
  { code: "fuel_cost",          label: "Fuel",              group: "expense" },
  { code: "insurance_cost",     label: "Insurance",         group: "expense" },
  { code: "registration_cost",  label: "Registration / LTO", group: "expense" },
  { code: "cleaning_cost",      label: "Cleaning / detailing", group: "expense" },
  { code: "staff_cost",         label: "Staff cost",        group: "expense" },
  { code: "driver_compensation", label: "Driver compensation", group: "expense" },
  { code: "driver_service_charge", label: "Driver service charge", group: "income" },
  { code: "other",              label: "Other",             group: "expense" },
];

export const recordMeta = (code) =>
  RECORD_TYPES.find((r) => r.code === code) ||
  { code, label: code, group: "expense" };

export const PAYMENT_METHODS = [
  { value: "",              label: "-" },
  { value: "cash",          label: "Cash" },
  { value: "gcash",         label: "GCash" },
  { value: "maya",          label: "Maya" },
  { value: "card",          label: "Card" },
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "paymongo",      label: "PayMongo" },
  { value: "stripe",        label: "Stripe" },
  { value: "other",         label: "Other" },
];

export const STATUS_OPTIONS = [
  { value: "paid",      label: "Paid",      tone: "emerald" },
  { value: "pending",   label: "Pending",   tone: "amber" },
  { value: "refunded",  label: "Refunded",  tone: "slate" },
  { value: "cancelled", label: "Cancelled", tone: "rose" },
];

export const DOC_TYPES = [
  { code: "business_permit",       label: "Business permit" },
  { code: "vehicle_registration",  label: "Vehicle registration (OR/CR)" },
  { code: "insurance",             label: "Insurance" },
  { code: "receipt",               label: "Receipt" },
  { code: "rental_agreement",      label: "Rental agreement" },
  { code: "driver_license_copy",   label: "Driver's license copy" },
  { code: "other",                 label: "Other" },
];

export const fmtPHP = (n) => {
  const v = Number(n || 0);
  return "₱" + v.toLocaleString("en-PH", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

// Used for chip color on lists / overview cards.
export const statusTone = (status) => {
  const map = {
    paid:      "bg-emerald-50 text-emerald-800 border-emerald-200",
    pending:   "bg-amber-50 text-amber-800 border-amber-200",
    refunded:  "bg-slate-100 text-slate-700 border-slate-200",
    cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return map[status] || map.paid;
};
